import { render, staticRenderFns } from "./Chalets.vue?vue&type=template&id=47902769"
import script from "./Chalets.vue?vue&type=script&lang=js"
export * from "./Chalets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports